import { render, staticRenderFns } from "./panel-description.vue?vue&type=template&id=4b0f255c&scoped=true"
import script from "./panel-description.vue?vue&type=script&lang=js"
export * from "./panel-description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f255c",
  null
  
)

export default component.exports